<template>
    <div class="email-synced email-synced--block">
        <div class="email-synced__top">
            <div>
                <p class="email-synced__title">{{ $l10n.__('Adresse email synchronisée') }}</p>
                <p class="email-synced__content">{{ email }}</p>
            </div>
            <div>
                <CompassButton
                    v-if="showDisconnectButton"
                    :label="$t.__('email.disconnect_my_email')"
                    type="secondary-destructive"
                    size="medium"
                    @click="logout"
                ></CompassButton>
            </div>
        </div>
        <div class="email-synced__bottom">
            <p class="email-synced__title">{{ $l10n.__('État de connexion') }}</p>
            <div class="email-synced__state">
                <CompassTag :color="statusButtonStyle">
                    {{ syncStatus.message }}
                </CompassTag>
                <CompassPlainButton
                    :label="$t.__('email.EmailSettingAccountSynced.update')"
                    @click="updateStatus"
                />
            </div>
        </div>
    </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import emailStatuses from 'Dictionaries/emailStatuses';
const { mapState: mapStateUser } = createNamespacedHelpers('user');

export default {
    name: 'EmailSettingAccountSynced',
    props: {
        status: {
            type: String,
            required: false,
            default: '',
        },
        email: {
            type: String,
            required: false,
            default: '',
        },
        isEmailsSentFromCorp: {
            type: Boolean,
            required: true,
        },
    },
    computed: {
        ...mapStateUser({
            isAdmin: 'isAdmin',
        }),
        showDisconnectButton() {
            return this.isAdmin || !this.isEmailsSentFromCorp;
        },
        syncStatus() {
            return emailStatuses[this.status] || emailStatuses.default;
        },
        statusButtonStyle() {
            return this.syncStatus.color;
        },
    },
    methods: {
        updateStatus() {
            this.$emit('updateEmailStatus');
        },
        logout() {
            this.$emit('handleDisplayDialog');
        },
    },
};
</script>

<style lang="scss" scoped>
.email-synced {
    border: 1px solid var(--colors-common-border-default);
    border-radius: 4px;
    padding: var(--spacing-3);

    &__title {
        margin-bottom: 4px;
        margin-top: var(--spacing-0);
        font-weight: 600;
    }

    &__content {
        margin: 0;
    }

    &__top {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    &__bottom {
        margin-top: var(--spacing-3);
    }

    &__state {
        display: flex;
        align-items: center;
        gap: var(--spacing-1);
    }
}
</style>
